import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {CmsProductCarouselComponent as model, Product, ProductScope, ProductService} from '@spartacus/core';
import { CmsComponentData, ProductCarouselComponent } from '@spartacus/storefront';
import {filter, map, tap} from 'rxjs/operators';
import { UigProductCarouselComponentData as uigModel } from '../uig-product.models';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-uig-product-carousel',
    templateUrl: './uig-product-carousel.component.html',
    styleUrls: ['./uig-product-carousel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductCarouselComponent extends ProductCarouselComponent implements OnInit{

  protected readonly UIG_PRODUCT_SCOPE = ProductScope.LIST;

  public productsVisibleAtOnce: number = 1;
  public showSummary: boolean = false;
  public showUspInfo: boolean = false;
  public showUspInfoInRed: boolean = false;
  public showPriceInRed: boolean = false;
  private extendedComponentData$ = this.componentData.data$;
  private uigComponentData$: Observable<model> = this.componentData.data$.pipe(
      filter((data) => Boolean(data))
  );

  items$: Observable<Observable<Product | undefined>[]> =
      this.uigComponentData$.pipe(
          map((data) => data.productCodes?.trim().split(' ') ?? []),
          map((codes) =>
              codes.map((code) =>
                  this.productService.get(code, [...this.UIG_PRODUCT_SCOPE])
              )
          )
      );
  constructor(
    protected componentData: CmsComponentData<uigModel>,
    protected productService: ProductService
  ) {
    super(componentData, productService);
  }

  ngOnInit(): void {
    this.extendedComponentData$
    .pipe(
      filter((data) => data != null),
      tap((data) => {
        this.productsVisibleAtOnce = data.productsVisibleAtOnce;
        this.showSummary = data.showSummary;
        this.showUspInfo = data.showUspInfo;
        this.showUspInfoInRed = data.showUspInfoInRed;
        this.showPriceInRed = data.showPriceInRed;
      })
    )
    .subscribe();
  }

  public getItemWidth(): string {
    const widthPercentageValue: number = Math.floor(100 / this.productsVisibleAtOnce);
    return `${widthPercentageValue}%`;
  }
}
